module.exports = __webpack_public_path__ + "static/media/tiktok_icon.47da337e.png";